import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find } from '@fretadao/f-js-dom';
import { isBetween, isBlank, isPresent } from '@fretadao/f-js-utils';

application.register('remote-form', class extends Controller {
  static targets = ['form'];
  static values = {
    followRedirectOnSuccess: Boolean,
    showAlerts: Boolean,
    successAlert: String,
    failureAlert: String,
    href: String,
    successTitle: String,
    failureTitle: String,
    successButtonText: String,
    failureButtonText: String,
    refreshFormId: String
  };

  connect() {
    this.#bindAjaxEventsToForm();
    this.successModal = this.application.getControllerForElementAndIdentifier(find('#success-alert'), "modal");
    this.errorModal = this.application.getControllerForElementAndIdentifier(find('#error-alert'), "modal");
  }

  onPostSuccess(event) {
    this.#refreshForm(event);
    const response = event.detail[2];
    const redirectPath = response.getResponseHeader('location');
    this.#notice(this.successTitleValue, this.successAlertValue, this.successButtonTextValue, 'success', redirectPath);

    if (this.hasRefreshFormIdValue) this.#scrollTo(this.formTarget);
    else this.#scrollTo(this.formTarget.parentElement);
  }

  onPostError(event) {
    if (this.#isServerError(event)) {
      this.#notice(
        'Ocorreu um erro inesperado',
        'Por favor, entre em contato com nossa equipe para mais detalhes, através do e-mail suporte@fretadao.com.br.'
      );
      this.#scrollTo(this.formTarget.parentElement);
    }
    else {
      this.#notice(this.failureTitleValue, this.failureAlertValue, this.failureButtonTextValue, 'error');
      this.#refreshForm(event);
    }
  }

  #refreshForm(event) {
    const [response, _status, _xhr] = event.detail;
    const formContainer = this.formTarget.parentElement;

    let responseForm = undefined;

    if (this.hasRefreshFormIdValue) {
      responseForm = find(`form#${this.refreshFormIdValue}`, response.documentElement);
    } else {
      responseForm = find('form', response.documentElement);
    }

    formContainer.innerHTML = responseForm.outerHTML;
    this.#bindAjaxEventsToForm();
    this.#scrollTo(formContainer);
  }

  #bindAjaxEventsToForm() {
    this.formTarget.addEventListener('ajax:success', this.onPostSuccess.bind(this));
    this.formTarget.addEventListener('ajax:error', this.onPostError.bind(this));
  }

  #isServerError(event) {
    const [_response, _status, xhr] = event.detail;

    return isBetween(xhr.status, 500, 599);
  }

  #scrollTo(element) {
    element.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  #notice(title, message, buttonText, type = 'success', redirectPath = null) {
    if (this.showAlertsValue) {
      const alertModal = type === 'success' ? this.successModal : this.errorModal;

      if (!isBlank(redirectPath) && type === 'success') alertModal.buttonTarget.setAttribute('href', redirectPath);

      alertModal.titleValue = title;
      alertModal.messageValue = message;
      alertModal.buttonLabelValue = buttonText;
      alertModal.open();
    } else if (this.followRedirectOnSuccessValue) {
      if (isPresent(redirectPath) && type === 'success') window.location.href = redirectPath;
    }
  }
});
